import { linkTooltipPlugin } from './TooltipPlugin';
import { addLinkCmd2, linkActionSpec2 } from './actions';
const linkAction2 = 'addLink';
export const LinkEnhance = (builder, opts) => {
    builder.addAction(linkAction2, linkActionSpec2).addPlugin(linkTooltipPlugin);
    if (opts === null || opts === void 0 ? void 0 : opts.linkKey) {
        const { linkKey } = opts;
        builder.addKeymap((deps) => ({
            [linkKey]: addLinkCmd2(deps),
        }));
    }
};
